import { Options, Vue } from 'vue-class-component';
import { isApp } from '@/services/environmentService';
import store from '@/store/store';
import { Link } from '@/cms/definitions/content-types';
import { PropType } from 'vue';

@Options({
	name: 'CookieFooter',
	props: {
		footerLinks: Object as PropType<Link>,
	},
})
export default class CookieFooter extends Vue {
	footerLinks: Link[];

	public get isThemed() {
		return store.getters.getThemeContext;
	}

	public isLoggedInAsApp() {
		return isApp;
	}
}
